import apiClient from '../client'
import type { OcrSuccessStatsResponse } from './types'

export const ocrSuccessStatsApi = {
  list(params?: {
    municipalityCode?: string
    municipalityName?: string
    importNo?: string
    identId?: string
    householdIdentCode?: string
    fileName?: string
    dateFrom?: string
    dateTo?: string
    sortBy?: string
    order?: 'ASC' | 'DESC'
    page?: number
    size?: number
  }) {
    return apiClient.get<OcrSuccessStatsResponse>('/api/admin/ocr-success-stats', { params })
  },

  exportCsv(params?: {
    municipalityCode?: string
    municipalityName?: string
    importNo?: string
    identId?: string
    householdIdentCode?: string
    fileName?: string
    dateFrom?: string
    dateTo?: string
    sortBy?: string
    order?: 'ASC' | 'DESC'
  }) {
    return apiClient.get('/api/admin/ocr-success-stats/export', {
      params,
      responseType: 'blob',
    })
  },
}
